import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';

import publicClient from '../../api/publicClient';
import { useAuth } from '../../contexts/AuthContext';

function GuestAccessPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const tokenRef = useRef(String(window.location.hash || '').replace(/^#/, ''));
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.history.replaceState(null, '', '/gastzugang');
    const rawToken = tokenRef.current;
    if (!rawToken) {
      setError('Dieser Gastzugang ist unvollständig. Bitte verwenden Sie den vollständigen Link aus der E-Mail.');
      setLoading(false);
      return;
    }

    publicClient.post('/api/auth/guest-access', { token: rawToken })
      .then((response) => {
        login(response.data.token, response.data.user);
        navigate('/einsatz/datenaustausch', { replace: true });
      })
      .catch((requestError) => {
        setError(requestError.response?.data?.error || 'Der Gastzugang konnte nicht geöffnet werden.');
        setLoading(false);
      });
  }, [login, navigate]);

  return (
    <Stack spacing={3} alignItems="center" sx={{ width: '100%', py: 4 }}>
      <Box component="img" src="/logo.jpeg" alt="Höhenrettung Logo" sx={{ width: 112, height: 112, objectFit: 'contain', borderRadius: 1 }} />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h5" sx={{ fontWeight: 800 }}>Gastzugang Datenaustausch</Typography>
        <Typography color="text.secondary">Der sichere Zugang wird vorbereitet.</Typography>
      </Box>
      {loading ? <CircularProgress /> : null}
      {error ? (
        <>
          <Alert severity="error" sx={{ width: '100%' }}>{error}</Alert>
          <Button startIcon={<LoginIcon />} onClick={() => navigate('/login', { replace: true })}>Zur Anmeldung</Button>
        </>
      ) : null}
    </Stack>
  );
}

export default GuestAccessPage;